import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import {Router} from "@angular/router";

@Component({
    standalone: false,
    selector: 'particle-analytics-entry-dialogue',
  templateUrl: './analytics-entry-dialogue.component.html',
  styleUrls: ['./analytics-entry-dialogue.component.scss']
})
export class AnalyticsEntryDialogueComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AnalyticsEntryDialogueComponent>,
              public router: Router) { }

  ngOnInit() {

  }
  closeDialog(){
    this.dialogRef.close(false);
  }
  redirectToProjectSettings(){
    this.dialogRef.close(true);
    //this.router.navigate(['/edit-project'])
  }
}
